import React from "react";
import { getTextEllipse } from "../../../core/utils/functions";
import "./carrousel.scss";

export function Carrousel({
  isLoaded = false,
  image,
  title,
  buttonLabel = "See More",
  description,
  id,
  slug,
  onReadMore,
}) {
  const Skeleton = () => (
    <div className="skeleton_carrousel_container">
      <div className="skeleton_carrousel__image_container"></div>
      <div className="skeleton_carrousel__details_container">
        <h3 data-testid="skeleton_carrousel__title"></h3>
        <p data-testid="skeleton_carrousel__description" />
        <button data-testid="skeleton_carrousel__btn"></button>
      </div>
    </div>
  );

  return (
    <>
      {isLoaded ? (
        <div data-testid="carrousel_container" className="carrousel_container">
          <div className="carrousel__image_container">
            <img src={image} />
          </div>
          <div className="carrousel__details_container">
            <h3 data-testid="carrousel__title">{title}</h3>
            <div
              data-testid="carrousel__description"
              dangerouslySetInnerHTML={{
                __html: getTextEllipse(description, 200, true),
              }}
            />
            <button
              data-testid="carrousel__btn"
              className="Button Primary-Outline"
              onClick={() => onReadMore?.(id, slug)}
            >
              {buttonLabel}
            </button>
          </div>
        </div>
      ) : (
        <Skeleton />
      )}
    </>
  );
}
